import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';
import { WmSelectModule } from '../select/index';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [DropdownComponent],
	imports: [CommonModule, WmTransitionModule, WmCardModule, WmSelectModule, FormsModule],
	exports: [DropdownComponent]
})
export class WmDropdownModule {}
